import src from "IMAGE";
export default { src, width: 3413, height: 600, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AGpqamlaWlpWe3t7Rpubm1GYmJhUjo6OUY2NjVOEhIRO7HYO0Ep7BnoAAAAASUVORK5CYII="};
